import React, { useState } from "react";

import CustomChip from "../../../shared/CustomChip";
import { useTranslation } from "react-i18next";
import ConfirmationModal from "../../../shared/ConfirmationModal";
import { MdCancel, MdEditNote } from "react-icons/md";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { getVisitsList } from "../../../redux/slices/VisitsSlice";
import { filterPayload } from "./VisitsFilters";
import { fetchData } from "../../../helpers/fetchData";
import ReusableModal from "../../../shared/ReuseableModal";
import moment from "moment";
import { BiSolidUserDetail } from "react-icons/bi";
import CheckPermission from "../../../hooks/CheckPermission";
import { useNavigate } from "react-router-dom";
import { CancelIcon, EditIcon } from "../../../utils/TableActionIcons";
import CancelAppointmentForm from "../appointments/CancelAppointmentForm";
import { FaCalendarAlt, FaFemale, FaMale, FaRegClock } from "react-icons/fa";
import { TiTick } from "react-icons/ti";
import { isShowDateOfBirth } from "../../../utils/businessLevelAccess";
import { MdOutlineAdd } from "react-icons/md";
import { CalculateAge } from "../../../utils/CalculateAge";
import { IoTimeOutline } from "react-icons/io5";
import ActionButton from "./ActionButton";

const AppointmentDetailCard = ({
  appointmentData,
  getVisitDataPayload,
  visitColor,
  practitionerDepartmentList,
  orderData,
  order,
  getOrdersPayload,
}) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [openCancelAppointmentModal, setOpenCancelAppointmentModal] =
    useState(false);
  const [openCompleteAppointmentModal, setOpenCompleteAppointmentModal] =
    useState(false);
  const [openHoldModal, setOpenHoldModal] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const auth = useSelector(state => state.auth);

  const endDateTimeStr =
    appointmentData?.date + " " + appointmentData?.end_time;
  const endTime = moment(endDateTimeStr, "YYYY-MM-DD HH:mm");
  const currentTime = moment();

  const { hasPermission } = CheckPermission();
  const selectedPractitioner = practitionerDepartmentList
    ?.flatMap((dept) => dept.practitioners)
    ?.find((p) => p.practitioner_id === getVisitDataPayload?.practitioner_id);

  const handleCancelAppointment = async (reason) => {
    setButtonLoading(true);
    const payload = {
      appointment_id: appointmentData?.appointment_id,
      practitioner_id: selectedPractitioner?.practitioner_id,
      cancellation_reason: reason,
    };

    await fetchData("POST", "/v3/appointments/cancel", payload).then(
      async (res) => {
        if (res) {
          toast.success(res?.message);
          setOpenCancelAppointmentModal(false);
          let getPayload = {
            ...getVisitDataPayload,
            start_date: moment(getVisitDataPayload?.start_date).format(
              "YYYY-MM-DD"
            ),
            end_date: moment(getVisitDataPayload?.start_date).format(
              "YYYY-MM-DD"
            ),
          };
          dispatch(getVisitsList(filterPayload(getPayload)));
        }
      }
    );
    setButtonLoading(false);
  };

  const handleConfirmAppointment = async (values) => {
    setButtonLoading(true);
    let payload = {
      day: moment(appointmentData?.date).format("dddd"),
      practitioner_id: appointmentData?.practitioner?.practitioner_id,
      appointment_id: appointmentData?.appointment_id,
    };

    let response = await await fetchData(
      "POST",
      "/v3/appointments/complete",
      payload
    );
    if (response) {
      toast.success(response?.message);
      let getPayload = {
        ...getVisitDataPayload,
        start_date: moment(getVisitDataPayload?.start_date).format(
          "YYYY-MM-DD"
        ),
        end_date: moment(getVisitDataPayload?.start_date).format("YYYY-MM-DD"),
      };
      dispatch(getVisitsList(filterPayload(getPayload)));
      setOpenCompleteAppointmentModal(false);
    }

    setButtonLoading(false);
  };
  const handleHoldSubmit = async (values) => {
    setButtonLoading(true);
    let payload = {
      day: moment(appointmentData?.date).format("dddd"),
      practitioner_id: appointmentData?.practitioner?.practitioner_id,
      hold_reason: values?.hold_reason,
      appointment_id: appointmentData?.appointment_id,
    };
    let response = await await fetchData(
      "POST",
      "/v3/appointments/hold",
      payload
    );
    if (response) {
      toast.success(response?.message);
      let getPayload = {
        ...getVisitDataPayload,
        start_date: moment(getVisitDataPayload?.start_date).format(
          "YYYY-MM-DD"
        ),
        end_date: moment(getVisitDataPayload?.start_date).format("YYYY-MM-DD"),
      };
      dispatch(getVisitsList(filterPayload(getPayload)));
      setOpenHoldModal(false);
    }

    setButtonLoading(false);
  };
  const handleNavigateCreateVisit = async () => {
    let date = moment(getVisitDataPayload?.start_date).format("YYYY-MM-DD");
    let start_time = appointmentData?.start_time;
    let end_time = appointmentData?.end_time;
    let day = moment(getVisitDataPayload?.start_date).format("dddd");
    let selectedPractitionerId = getVisitDataPayload?.practitioner_id;

    let patientDetails = appointmentData?.patient;

    if (
      !patientDetails?.beneficiary_type ||
      !patientDetails?.document_id ||
      !patientDetails?.gender
    ) {
      const res = await fetchData("POST", "/v3/patient/filter", {
        document_id: patientDetails?.document_id,
      });

      if (res?.data && res.data.length > 0) {
        patientDetails = res.data[0];
      } else {
        navigate("/create-beneficiary", {
          state: {
            beneficiaryDetailsFromAppointment: patientDetails,
            getBeneficiariesPayload: {
              page: 1,
              perPage: 10,
              contact: "",
              document_id: "",
              file_no: "",
              full_name: "",
            },
          },
        });
        return;
      }
    }

    if (appointmentData?.order_no && order) {
      navigate("/create-special-visit", {
        state: {
          orderData: orderData,
          getOrdersPayload: getOrdersPayload,
          start_time,
          day,
          date,
          end_time,
        },
      });
    } else {
      navigate("/create-visit", {
        state: {
          start_time,
          end_time,
          appointment_id: appointmentData?.appointment_id,
          day,
          date,
          selectedPractitionerId,
          patientDetails: patientDetails,
          isCreatedFromAppointment: true,
          tab: getVisitDataPayload?.visit_category,
        },
      });
    }
  };

  const handleRescheduleNavigate = () => {
    navigate("/create-appointment-from-visit", {
      state: {
        order,
        orderData,
        slot_time: appointmentData?.start_time,
        selectedDate: appointmentData?.date,
        practitionerData: selectedPractitioner,
        selectedAppointmentData: appointmentData,
        getVisitPayload: getVisitDataPayload,
        is_rescehedule: true,
      },
    });
  };

  const handleNewAppointmentNavigate = () => {
    navigate("/create-appointment-from-visit", {
      state: {
        slot_time: null,
        selectedDate: null,
        order,
        orderData,
        practitionerData: selectedPractitioner,
        selectedAppointmentData: appointmentData,
        getVisitPayload: getVisitDataPayload,
        isNewAppoinetmentFromPrev: true,
      },
    });
  };


  return (
    <div className="flex flex-col lg:flex-row w-full items-stretch min-h-auto relative bg-white overflow-hidden ">
      <div className="flex-1 lg:flex-[1.5] flex flex-col border-b lg:border-b-0 bg-white">
        <div className={`w-full  h-auto min-h-[50px] flex flex-wrap items-center gap-2 px-3 cursor-pointer py-1 ${visitColor}`}>
          <span
            className={`flex items-center justify-center w-6 h-6 rounded-full 
                        ${appointmentData?.patient?.gender === 'female'
                ? 'bg-rose-100 text-rose-600'
                : appointmentData?.patient?.gender === 'male'
                  ? 'bg-sky-100 text-sky-600'
                  : null
              }`}
          >
            {appointmentData?.patient?.gender === 'female' ? (
              <FaFemale size={18} />
            ) : appointmentData?.patient?.gender === 'male' ? (
              <FaMale size={18} />
            ) : null}
          </span>
          <span className="text-[15px] font-bold text-gray-700 uppercase truncate flex-1 leading-none" title={`${t("MRN")}: ${appointmentData?.patient?.file_no}${appointmentData?.patient?.old_file_no ? `, ${t("Old MRN")}: ${appointmentData?.patient?.old_file_no}` : ""}`}>
            {appointmentData?.patient?.full_name} ({appointmentData?.patient?.file_no}{appointmentData?.patient?.old_file_no ? <span> / {t("Old MRN")}: <span className="text-red-500">{appointmentData?.patient?.old_file_no}</span></span> : ""})
          </span>
        </div>

        <div className="px-4 py-2 flex-1 flex items-center min-h-[50px] bg-white">
          <div className="flex flex-wrap items-center gap-3">

            <span className="text-[13px] font-semibold text-gray-800">
              {appointmentData?.patient?.document_id || "--"}
            </span>


            <span className="text-gray-300 font-light">|</span>

            {appointmentData?.patient?.dob && (
              <>
                <span className="text-[13px] font-medium text-gray-600 whitespace-nowrap">
                  {isShowDateOfBirth(auth?.user) ? appointmentData?.patient?.dob : CalculateAge(appointmentData?.patient?.dob)}
                </span>
              </>
            )}

            <span className="text-gray-300 font-light">|</span>
            <div className="flex items-center gap-1.5 text-gray-500">
              <FaRegClock size={12} className="text-gray-400" />
              <span className="text-[13px] font-medium">
                {appointmentData?.start_time} - {appointmentData?.end_time}
              </span>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-2 px-3 py-2 border-t border-gray-100 mt-auto bg-gray-50/50 h-auto min-h-[45px]">
          <p className="text-[11px] font-semibold text-gray-700 px-2 py-0.5 bg-gray-100 rounded uppercase">
            {t(appointmentData?.patient?.beneficiary_type) || t("Cash")}
          </p>
          <div className="h-3 w-[1px] bg-gray-200"></div>
          <p className="text-[11px] font-semibold text-gray-500 uppercase truncate max-w-[150px]">
            {t("EP")}: {appointmentData?.appointment_id}
          </p>

        </div>
      </div>

      <div className="flex-1 flex flex-col bg-white">
        <div className={`w-full h-auto min-h-[50px] flex flex-wrap items-center justify-end gap-2 px-3  py-1 ${visitColor}`}>
          <div className="flex items-center gap-2">
            <CustomChip
              label={appointmentData?.status === "Completed" ? "Fulfilled" : appointmentData?.status}
              chipType="mono-light"
              className="cursor-pointer whitespace-nowrap transition-all !bg-gray-50 !text-gray-500 !border-gray-200"
              labelClassName="!text-[12px] !uppercase"
            />
          </div>

          <div className="flex items-center gap-2">
            {hasPermission("appointments", "update") &&
              appointmentData?.status !== "Cancelled" &&
              appointmentData?.status !== "Arrived" && (
                <ActionButton
                  variant="danger"
                  icon={<MdCancel />}
                  onClick={() => setOpenCancelAppointmentModal(true)}
                  title={t("Cancel Appointment")}
                />
              )}
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-start lg:justify-end px-3 py-2 gap-2 flex-1 h-auto">
          {appointmentData?.act_priority && (
            <CustomChip
              chipType="mono-outline"
              label={t(appointmentData?.act_priority?.coding?.[0]?.display) || "NORMAL"}
              className={`whitespace-nowrap transition-all ${["em"].includes(appointmentData?.act_priority?.coding?.[0]?.code?.toLowerCase()) ? "!bg-red-200 !text-red-500 !border-red-500" : "!bg-gray-50 !text-gray-500 !border-gray-200"}`}
              labelClassName="!text-[12px] !uppercase"
            />
          )}

          {appointmentData?.note && (
            <div className="px-3 py-1 bg-amber-50 border border-amber-100 rounded max-w-[200px] truncate" title={appointmentData?.note}>
              <p className="text-[10px] font-semibold text-amber-700 uppercase leading-tight">
                {appointmentData?.note}
              </p>
            </div>
          )}
        </div>

        <div className="flex flex-wrap items-center justify-start lg:justify-end gap-2 px-3 py-2 border-t border-gray-100 mt-auto bg-gray-50/50 h-auto min-h-[45px]">
          <div className="flex items-center gap-1.5">
            {appointmentData?.status == "Cancelled" &&
              hasPermission("appointments", "update") && (
                <ActionButton
                  variant="primary"
                  icon={<MdEditNote />}
                  onClick={handleRescheduleNavigate}
                  title={t("Reschedule")}
                />
              )}

            {hasPermission("appointments", "update") &&
              appointmentData?.status !== "Cancelled" &&
              appointmentData?.status !== "Arrived" && (
                <>
                  <ActionButton
                    variant="primary"
                    icon={<TiTick />}
                    onClick={() => setOpenCompleteAppointmentModal(true)}
                    title={t("Arrive")}
                  />
                  {appointmentData?.status !== "Waitlisted" && (
                    <ActionButton
                      variant="primary"
                      icon={<IoTimeOutline />}
                      onClick={() => setOpenHoldModal(true)}
                      title={t("Hold")}
                    />
                  )}
                  {hasPermission("appointments", "update") &&
                    appointmentData?.status !== "Fulfilled" &&
                    appointmentData?.status !== "Completed" && (
                      <ActionButton
                        variant="primary"
                        icon={<EditIcon iconSize={18} className="mx-0 !text-blue" />}
                        onClick={() => navigate(`/edit-appointment/${appointmentData?.appointment_id}`)}
                        title={t("Edit")}
                      />
                    )}
                </>
              )}

            {hasPermission("appointments", "create") &&
              (appointmentData?.status === "Cancelled" ||
                appointmentData?.status === "Arrived") && (
                <ActionButton
                  variant="primary"
                  icon={<FaCalendarAlt size={18} />}
                  sizeChange={false}
                  onClick={handleNewAppointmentNavigate}
                  title={t("New Appointment")}
                />
              )}

            {hasPermission("visit", "create") &&
              appointmentData?.status === "Arrived" && (
                <ActionButton
                  variant="primary"
                  icon={<MdOutlineAdd size={24} />}
                  sizeChange={false}
                  onClick={handleNavigateCreateVisit}
                  title={t("Create Visit")}
                />
              )}
          </div>
        </div>
      </div>
      <ReusableModal
        className="w-full md:w-[90%] lg:w-[800px]"
        position="top"
        title={t("Cancel Appointment")}
        isVisible={openCancelAppointmentModal}
        HeaderIcon={CancelIcon}
        onClose={() => {
          setOpenCancelAppointmentModal(false);
        }}
      >
        <CancelAppointmentForm
          handleCancel={handleCancelAppointment}
          cancelLoading={buttonLoading}
        />
      </ReusableModal>

      {/* <ReusableModal
        className="w-full md:w-[90%] lg:w-[800px]"
        position="top"
        title={`Hold appointment of ${moment(appointmentData?.date).format(
          "D MMMM"
        )} ${appointmentData?.start_time}`}
        isVisible={openHoldModal}
        HeaderIcon={BiSolidUserDetail}
        onClose={() => {
          setOpenHoldModal(false);
        }}
      >
        <HoldAppointmentForm
          setOpenModal={setOpenHoldModal}
          selectedAppointmentData={appointmentData}
          getDataPayload={getVisitDataPayload}
        />
      </ReusableModal> */}

      <ConfirmationModal
        isLoading={buttonLoading}
        visible={openCompleteAppointmentModal}
        onAccept={() => {
          handleConfirmAppointment();
        }}
        setVisible={setOpenCompleteAppointmentModal}
        onReject={() => setOpenCompleteAppointmentModal(false)}
        header={t("Confirm Arrival")}
        acceptLabel={t("Arrived")}
        rejectLabel={t("Cancel")}
      />
      <ConfirmationModal
        isLoading={buttonLoading}
        visible={openHoldModal}
        onAccept={() => {
          handleHoldSubmit();
        }}
        setVisible={setOpenHoldModal}
        onReject={() => setOpenHoldModal(false)}
        header={`${t("WaitList appointment of")} ${moment(appointmentData?.date).format(
          "D MMMM"
        )} ${appointmentData?.start_time}`}
        Icon={BiSolidUserDetail}
        acceptLabel={t("Waitlist")}
        rejectLabel={t("Cancel")}
      />
      {/* <ReusableModal
        className='w-full md:w-[90%] lg:w-[800px]'
        position='top'
        title={`Complete appointment of ${moment(appointmentData?.date).format(
          'D MMMM'
        )} ${appointmentData?.start_time}`}
        // isVisible={openCompleteAppointmentModal}
        HeaderIcon={BiSolidUserDetail}
        onClose={() => {
          setOpenCompleteAppointmentModal(false)
        }}
      >
        <CompleteAppointmentForm
          setOpenModal={setOpenCompleteAppointmentModal}
          selectedAppointmentData={appointmentData}
          getDataPayload={getVisitDataPayload}
        />
      </ReusableModal> */}

    </div>
  );
};

export default AppointmentDetailCard;
